import { Field, Formik } from "formik";
import React from "react";
import { Modal } from "react-bootstrap";
import { Input, Select } from "../../../../_metronic/_partials/controls";

const EmailConfiguration = ({ show, onHide, onSubmit, initialValues = {} }) => {
  const emailSecure = [
    { name: "False", value: false },
    { name: "True", value: true }
  ];

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        enableReinitialize
      >
        {({ setFieldValue, values, handleSubmit }) => (
          <>
            <Modal show={show} onHide={onHide}>
              <Modal.Header>
                <div>
                  <h4>Konfigurasi Email</h4>
                  <div className="d-flex">
                    <div>
                      <i
                        className="fas fa-exclamation-circle mr-2"
                        style={{ color: "red" }}
                      />
                    </div>
                    <strong>
                      Notifikasi email tidak akan terkirim jika konfigurasi
                      email tidak benar
                    </strong>
                  </div>
                </div>
              </Modal.Header>
              <Modal.Body>
                <div className="form-group row">
                  <div className="col">
                    <Field
                      name="email_host"
                      label="Email Host"
                      component={Input}
                      placeholder="Email Host"
                    />
                  </div>
                  <div className="col">
                    <Field
                      name="email_port"
                      label="Email Port"
                      component={Input}
                      placeholder="Email Port"
                      type="number"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col">
                    <Field
                      name="email_user"
                      label="Email User"
                      component={Input}
                      placeholder="Email User"
                    />
                  </div>
                  <div className="col">
                    <Field
                      name="email_pass"
                      label="Email Password"
                      component={Input}
                      placeholder="Email Password"
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <div className="col">
                    <label>
                      <strong>Email Secure</strong>
                    </label>
                    <Select name="email_secure">
                      {emailSecure.map(row => (
                        <option key={row.value} value={row.value}>
                          {row.name}
                        </option>
                      ))}
                    </Select>
                    {/* <Field
                      name="email_secure"
                      label="Email Secure"
                      component={Input}
                      placeholder="Email Host"
                    /> */}
                  </div>
                  <div className="col">
                    <Field
                      name="email_from"
                      label="Email From"
                      component={Input}
                      placeholder="Email From"
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="col">
                    <label>
                      <strong>Email TLS</strong>
                    </label>
                    <textarea
                      name="email_tls"
                      className="form-control"
                      placeholder="Contoh: { rejectUnauthorized: false, }"
                      onChange={e => setFieldValue("email_tls", e.target.value)}
                      value={values.email_tls}
                    />
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="btn btn-outline-danger"
                  onClick={() => {
                    setFieldValue("is_reset", true);
                    setFieldValue("is_test_email", false);
                    handleSubmit();
                  }}
                >
                  Reset Konfigurasi
                </button>
                <button
                  className="btn btn-warning"
                  onClick={() => {
                    setFieldValue("is_reset", false);
                    setFieldValue("is_test_email", true);
                    handleSubmit();
                  }}
                >
                  Test Kirim Email
                </button>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setFieldValue("is_reset", false);
                    setFieldValue("is_test_email", false);
                    handleSubmit();
                  }}
                >
                  Simpan
                </button>
              </Modal.Footer>
            </Modal>
          </>
        )}
      </Formik>
    </>
  );
};

export default EmailConfiguration;
